import { useEffect } from "react";
import { useBrowserNotifications } from "@/lib/useBrowserNotifications";

/**
 * Side effect aislado · dispara una notificación del browser cuando el
 * tamaño de la bandeja crece (llegó una solicitud nueva mientras esta
 * pestaña está en segundo plano).
 *
 * Solo orquesta · la lógica de "crece vs. baja" vive en el hook
 * `useBrowserNotifications.notificarSiCrece` que mantiene el estado
 * previo internamente.
 */
export function useNotificarLlegada(total: number) {
  const { permiso, solicitar, notificarSiCrece } = useBrowserNotifications();

  useEffect(() => {
    notificarSiCrece(total, {
      titulo: "Multiva · nueva solicitud por autorizar",
      cuerpo: `Tienes ${total} pendientes en tu bandeja.`,
      tag: "multiva-bandeja-autorizacion",
    });
  }, [total, notificarSiCrece]);

  return { permiso, solicitar };
}
